/* eslint-disable import/no-commonjs */
const chalk = require('chalk')

const getColor = level => {
  switch (level) {
    case 'error': return 'red'
    case 'warning': return 'yellow'
    case 'info': return 'blue'
    default: return 'white'
  }
}

const logMessage = (message, level = 'info') => {
  const color = getColor(level)
  console.log(`[${new Date().toISOString()}]`, chalk[color](message))
}

const compilerPromise = (name, compiler) => new Promise((resolve, reject) => {
  compiler.hooks.compile.tap(name, () => {
    logMessage(`[${name}] Compiling `)
  })

  compiler.hooks.done.tap(name, stats => {
    if (stats.hasErrors()) {
      const info = stats.toJson()
      console.log('BUILD ERRORS:', info.errors)
      return reject(new Error(`Failed to compile ${name}`))
    }
    return resolve()
  })
})

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const clientOnly = () => process.argv.includes('--client-only')

const getVariationValue = (variation) => {
  if (
    variation === "on" ||
    variation === "1" ||
    variation === "b" ||
    variation === "true" ||
    variation === "b1" ||
    variation === "b2"
  ) {
    return true;
  }
  if (
    variation === "off" ||
    variation === "0" ||
    variation === "a" ||
    variation === "false" ||
    variation === "a1" ||
    variation === "a2"
  ) {
    return false;
  }

  return false;
};

module.exports = {
  clientOnly,
  compilerPromise,
  logMessage,
  sleep,
  getVariationValue,
}
/* eslint-enable import/no-commonjs */
